export default "__VITE_ASSET__C_hcwil5__"